export default __webpack_public_path__ + "static/media/home-branding-agency-bg-img-01.a90895ff.png";